import CustomRegister from "./CustomRegister";
import CustomLogin from "./CustomLogin";
import ExhibitionCarousel2 from "./ExhibitionCarousel2";
import MuseumCarousel2 from "./MuseumCarousel2";
import ExhibitionCarousel3 from "./ExhibitionCarousel3";
import CustomSearch from "./CustomSearch";

import CustomVerification from "./CustomVerification";
import CustomForgotPassword from "./CustomForgotPassword";
import CarouselItemTemplate from "./CarouselItemTemplate";
import CustomEditProfile from "./CustomEditProfile";
import CustomAddArtworks from "./CustomAddArtworks";
import CustomAddPanel from "./CustomAddPanel";
import CustomGaleria from "./CustomGaleria";
import CustomFollowLayer from "./CustomFollowLayer";
import CustomAddImage from "./CustomAddImage";
import CustomInvite from "./CustomInvite";
import CustomExhibitions from "./CustomExhibitions";
import CustomArtLabel from "./CustomArtLabel";
import CustomUpdate from "./CustomUpdate";
import CustomFeaturedExhibitions  from "./CustomFeaturedSelectExhibit";
import CustomFeaturedSelectExhibit  from "./CustomFeaturedSelectExhibit";
import CustomFooter from "./CustomFooter";
import CustomSearchDetail from "./CustomSearchDetail";




export { 
    CustomRegister,
    CustomLogin,
    CustomSearch,
    CustomSearchDetail,
    CustomVerification,
    CustomForgotPassword,
    CarouselItemTemplate,
    CustomEditProfile,
    CustomAddArtworks,
    CustomAddPanel,
    CustomGaleria,
    ExhibitionCarousel2,
    MuseumCarousel2,
    ExhibitionCarousel3,
    CustomFollowLayer,
    CustomAddImage,
    CustomInvite,
    CustomExhibitions,
    CustomArtLabel,
    CustomUpdate,
    CustomFeaturedExhibitions,
    CustomFeaturedSelectExhibit,
    CustomFooter
}
